import React, { useEffect } from 'react';

const Contact = () => {
  useEffect(() => {
    // Funciones de validación
    const validateEmail = (email) => {
      const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      return re.test(email);
    };

    const validatePhone = (phone) => {
      const re = /^(\+?57\s?)?[0-9]{7,10}$|^(\+?[1-9]\d{1,14})$/;
      return re.test(phone.replace(/[\s\-\(\)]/g, ''));
    };

    const validateName = (name) => {
      const re = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]{2,50}$/;
      return re.test(name.trim());
    };

    const showFieldError = (field, message) => {
      const formGroup = field.closest('.form-group');
      let errorElement = formGroup.querySelector('.error-message');
      
      if (!errorElement) {
        errorElement = document.createElement('div');
        errorElement.className = 'error-message';
        errorElement.style.color = '#e74c3c';
        errorElement.style.fontSize = '0.85rem';
        errorElement.style.marginTop = '0.5rem';
        errorElement.style.padding = '0.3rem 0.5rem';
        errorElement.style.backgroundColor = '#ffeaea';
        errorElement.style.borderRadius = '4px';
        errorElement.style.border = '1px solid #f5c6cb';
        errorElement.style.animation = 'shake 0.3s ease-in-out';
        formGroup.appendChild(errorElement);
      }
      
      errorElement.textContent = message;
      field.style.borderColor = '#e74c3c';
      field.style.backgroundColor = '#fef9f9';
    };

    const clearFieldError = (field) => {
      const formGroup = field.closest('.form-group');
      const errorElement = formGroup.querySelector('.error-message');
      
      if (errorElement) {
        errorElement.remove();
      }
      
      field.style.borderColor = '';
      field.style.backgroundColor = '';
    };

    const showSuccessField = (field) => {
      field.style.borderColor = '#28a745';
      field.style.backgroundColor = '#f8fff9';
    };

    // Función para mostrar notificaciones
    const showNotification = (message, type = 'info') => {
      const existingNotifications = document.querySelectorAll('.notification');
      existingNotifications.forEach(notification => notification.remove());

      const notification = document.createElement('div');
      notification.className = `notification notification-${type}`;
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        color: white;
        font-weight: 500;
        z-index: 10000;
        max-width: 400px;
        box-shadow: 0 4px 15px rgba(0,0,0,0.2);
        animation: slideInRight 0.3s ease-out;
        backdrop-filter: blur(10px);
      `;

      if (type === 'success') {
        notification.style.background = 'linear-gradient(135deg, #27ae60, #2ecc71)';
      } else if (type === 'error') {
        notification.style.background = 'linear-gradient(135deg, #e74c3c, #c0392b)';
      } else {
        notification.style.background = 'linear-gradient(135deg, #3498db, #2980b9)';
      }

      notification.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <span>${message}</span>
          <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; color: white; font-size: 1.2rem; cursor: pointer; margin-left: 1rem;">×</button>
        </div>
      `;

      document.body.appendChild(notification);

      setTimeout(() => {
        if (notification.parentElement) {
          notification.style.animation = 'slideOutRight 0.3s ease-in';
          setTimeout(() => notification.remove(), 300);
        }
      }, 5000);
    };

    // Función para mostrar el email como respaldo
    const showEmailBackup = (data) => {
      const emailContent = `
Hola equipo de Resveltex SAS,

Han recibido una nueva consulta a través del sitio web:

📋 INFORMACIÓN DEL CLIENTE:
- Nombre: ${data.nombre}
- Empresa: ${data.empresa || 'No especificada'}
- Email: ${data.email}
- Teléfono: ${data.telefono || 'No especificado'}
- Tipo de Consulta: ${data.tipoConsulta || 'Contacto general'}

💬 MENSAJE:
${data.mensaje}

---
Este mensaje fue enviado desde el formulario de contacto de resveltex.com
Fecha: ${new Date().toLocaleString('es-CO')}
      `.trim();

      const modal = document.createElement('div');
      modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10001;
        backdrop-filter: blur(5px);
      `;

      modal.innerHTML = `
        <div style="
          background: white;
          border-radius: 12px;
          padding: 2rem;
          max-width: 600px;
          width: 90%;
          max-height: 80vh;
          overflow-y: auto;
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
          animation: slideIn 0.3s ease-out;
        ">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
            <h3 style="margin: 0; color: #2e2a73; font-size: 1.5rem;">📧 Email Preparado</h3>
            <button onclick="this.closest('.modal').remove()" style="
              background: none;
              border: none;
              font-size: 1.5rem;
              cursor: pointer;
              color: #666;
              padding: 0.5rem;
              border-radius: 50%;
              transition: background 0.2s;
            " onmouseover="this.style.background='#f0f0f0'" onmouseout="this.style.background='transparent'">×</button>
          </div>
          
          <div style="
            background: #f8f9fa;
            border: 1px solid #e9ecef;
            border-radius: 8px;
            padding: 1.5rem;
            margin-bottom: 1.5rem;
            font-family: monospace;
            white-space: pre-wrap;
            font-size: 0.9rem;
            line-height: 1.5;
            color: #333;
            max-height: 300px;
            overflow-y: auto;
          ">${emailContent}</div>
          
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button onclick="copyToClipboard('${emailContent.replace(/'/g, "\\'")}')" style="
              background: linear-gradient(135deg, #3498db, #2980b9);
              color: white;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 6px;
              cursor: pointer;
              font-weight: 500;
              transition: transform 0.2s;
            " onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
              📋 Copiar Contenido
            </button>
            <button onclick="window.open('mailto:ventas@resveltex.com?subject=${encodeURIComponent(`Nueva consulta de ${data.nombre} - ${data.tipoConsulta || 'Contacto'}`)}&body=${encodeURIComponent(emailContent)}')" style="
              background: linear-gradient(135deg, #27ae60, #2ecc71);
              color: white;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 6px;
              cursor: pointer;
              font-weight: 500;
              transition: transform 0.2s;
            " onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
              📧 Abrir Email
            </button>
          </div>
        </div>
      `;

      modal.className = 'modal';
      document.body.appendChild(modal);

      window.copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
          showNotification('Contenido copiado al portapapeles', 'success');
        }).catch(() => {
          const textArea = document.createElement('textarea');
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          showNotification('Contenido copiado al portapapeles', 'success');
        });
      };
    };

    // Manejo del formulario
    const contactForm = document.getElementById('contactForm');
    if (contactForm) {
      const handleSubmit = (e) => {
        e.preventDefault();
        
        const nombre = document.getElementById('nombre');
        const empresa = document.getElementById('empresa');
        const email = document.getElementById('email');
        const telefono = document.getElementById('telefono');
        const tipoConsulta = document.getElementById('tipo-consulta');
        const mensaje = document.getElementById('mensaje');
        
        let isValid = true;
        
        // Limpiar errores previos
        [nombre, empresa, email, telefono, mensaje].forEach(field => {
          if (field) clearFieldError(field);
        });
        
        // Validar nombre
        if (!nombre.value.trim() || nombre.value.trim().length < 2) {
          showFieldError(nombre, 'El nombre es obligatorio y debe tener al menos 2 caracteres');
          isValid = false;
        } else if (!validateName(nombre.value)) {
          showFieldError(nombre, 'El nombre solo puede contener letras y espacios');
          isValid = false;
        } else {
          showSuccessField(nombre);
        }
        
        // Validar email
        if (!email.value.trim()) {
          showFieldError(email, 'El correo electrónico es obligatorio');
          isValid = false;
        } else if (!validateEmail(email.value)) {
          showFieldError(email, 'Por favor ingresa un correo electrónico válido');
          isValid = false;
        } else {
          showSuccessField(email);
        }
        
        // Validar teléfono (opcional pero si se llena debe ser válido)
        if (telefono.value.trim() && !validatePhone(telefono.value)) {
          showFieldError(telefono, 'Por favor ingresa un número de teléfono válido (ej: +57 300 123 4567)');
          isValid = false;
        } else if (telefono.value.trim()) {
          showSuccessField(telefono);
        }
        
        // Validar mensaje
        if (!mensaje.value.trim()) {
          showFieldError(mensaje, 'El mensaje es obligatorio');
          isValid = false;
        } else if (mensaje.value.trim().length < 10) {
          showFieldError(mensaje, 'El mensaje debe tener al menos 10 caracteres');
          isValid = false;
        } else if (mensaje.value.trim().length > 500) {
          showFieldError(mensaje, 'El mensaje no puede exceder los 500 caracteres');
          isValid = false;
        } else {
          showSuccessField(mensaje);
        }
        
        if (!isValid) {
          return;
        }
        
        const submitBtn = contactForm.querySelector('.submit-btn');
        const submitSpan = submitBtn.querySelector('span');
        const originalText = submitSpan.textContent;
        
        // Agregar clase loading y spinner
        submitBtn.classList.add('loading');
        submitSpan.textContent = 'Enviando';
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.8';
        submitBtn.style.cursor = 'not-allowed';
        
        // Función para enviar el formulario usando mailto (100% gratuito)
        try {
          // Recopilar datos del formulario
          const data = {
            nombre: nombre.value.trim(),
            empresa: empresa.value.trim(),
            email: email.value.trim(),
            telefono: telefono.value.trim(),
            tipoConsulta: tipoConsulta.value,
            mensaje: mensaje.value.trim()
          };

          // Crear el contenido del email
          const subject = `Nueva consulta de ${data.nombre} - ${data.tipoConsulta || 'Contacto'}`;
          const body = `
Hola equipo de Resveltex SAS,

Han recibido una nueva consulta a través del sitio web:

📋 INFORMACIÓN DEL CLIENTE:
- Nombre: ${data.nombre}
- Empresa: ${data.empresa || 'No especificada'}
- Email: ${data.email}
- Teléfono: ${data.telefono || 'No especificado'}
- Tipo de Consulta: ${data.tipoConsulta || 'Contacto general'}

💬 MENSAJE:
${data.mensaje}

---
Este mensaje fue enviado desde el formulario de contacto de resveltex.com
Fecha: ${new Date().toLocaleString('es-CO')}
          `.trim();

          // Crear enlaces para Gmail y mailto
          const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=ventas@resveltex.com&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
          const mailtoLink = `mailto:ventas@resveltex.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

          // Intentar abrir Gmail primero
          const gmailWindow = window.open(gmailLink, '_blank');
          
          // Si Gmail no se abre, intentar con mailto
          if (!gmailWindow || gmailWindow.closed || typeof gmailWindow.closed == 'undefined') {
            window.location.href = mailtoLink;
            showNotification('Se abrirá tu cliente de email. Si no funciona, copia este email: ventas@resveltex.com', 'success');
          } else {
            showNotification('Se abrirá Gmail en una nueva pestaña. Por favor envía el mensaje.', 'success');
          }

          // Mostrar el email como respaldo
          setTimeout(() => {
            showEmailBackup(data);
          }, 1000);

        } catch (error) {
          console.error('Error al preparar el email:', error);
          showNotification('Error al preparar el email. Por favor escribe directamente a ventas@resveltex.com', 'error');
        }
        
        // Resetear el botón después de un tiempo
        setTimeout(() => {
          submitBtn.classList.remove('loading');
          submitSpan.textContent = originalText;
          submitBtn.disabled = false;
          submitBtn.style.background = '';
          submitBtn.style.opacity = '1';
          submitBtn.style.cursor = 'pointer';
          
          // Limpiar campos
          contactForm.reset();
          [nombre, empresa, email, telefono, mensaje].forEach(field => {
            if (field) {
              clearFieldError(field);
              field.style.borderColor = '';
              field.style.backgroundColor = '';
            }
          });
        }, 4000);
      };

      contactForm.addEventListener('submit', handleSubmit);
    }
  }, []);

  return (
    <div className="container">
      <h1 className="text-center mt-2">Contacto</h1>
      <div className="mt-2">
        <p>Esta es la página de contacto de RESVELTEX SAS.</p>
        <p>Aquí puedes agregar información de contacto y formularios.</p>
        
        {/* Formulario de contacto */}
        <div className="contact-form-container" style={{
          maxWidth: '600px',
          margin: '2rem auto',
          padding: '2rem',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ textAlign: 'center', marginBottom: '2rem', color: '#2e2a73' }}>
            Envíanos tu consulta
          </h2>
          
          <form id="contactForm" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            <div className="form-group">
              <label htmlFor="nombre" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Nombre Completo *
              </label>
              <input 
                type="text" 
                id="nombre" 
                name="nombre" 
                placeholder="Tu nombre completo" 
                required 
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '6px',
                  fontSize: '1rem',
                  transition: 'border-color 0.3s ease'
                }}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="empresa" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Empresa
              </label>
              <input 
                type="text" 
                id="empresa" 
                name="empresa" 
                placeholder="Nombre de tu empresa (opcional)" 
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '6px',
                  fontSize: '1rem',
                  transition: 'border-color 0.3s ease'
                }}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Correo Electrónico *
              </label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="ejemplo@correo.com" 
                required 
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '6px',
                  fontSize: '1rem',
                  transition: 'border-color 0.3s ease'
                }}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="telefono" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Teléfono
              </label>
              <input 
                type="tel" 
                id="telefono" 
                name="telefono" 
                placeholder="+57 300 123 4567" 
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '6px',
                  fontSize: '1rem',
                  transition: 'border-color 0.3s ease'
                }}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="tipo-consulta" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Tipo de Consulta
              </label>
              <select 
                id="tipo-consulta" 
                name="tipo-consulta"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '6px',
                  fontSize: '1rem',
                  transition: 'border-color 0.3s ease',
                  backgroundColor: 'white'
                }}
              >
                <option value="">Selecciona una opción</option>
                <option value="cotizacion">Solicitar Cotización</option>
                <option value="informacion">Información de Productos</option>
                <option value="distribucion">Ser Distribuidor</option>
                <option value="soporte">Soporte Técnico</option>
                <option value="otro">Otro</option>
              </select>
            </div>
            
            <div className="form-group">
              <label htmlFor="mensaje" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Mensaje *
              </label>
              <textarea 
                id="mensaje" 
                name="mensaje" 
                placeholder="Cuéntanos sobre tu proyecto, cantidad necesaria, colores específicos o cualquier consulta que tengas..." 
                required 
                rows="5"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '6px',
                  fontSize: '1rem',
                  transition: 'border-color 0.3s ease',
                  resize: 'vertical',
                  fontFamily: 'inherit'
                }}
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="submit-btn"
              style={{
                background: 'linear-gradient(135deg, #2e2a73, #4a90e2)',
                color: 'white',
                border: 'none',
                padding: '1rem 2rem',
                borderRadius: '8px',
                fontSize: '1.1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginTop: '1rem'
              }}
              onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
            >
              <span>Enviar Mensaje</span>
            </button>
          </form>
        </div>
        
        {/* Información de contacto */}
        <div className="contact-info" style={{
          textAlign: 'center',
          marginTop: '3rem',
          padding: '2rem',
          backgroundColor: '#2e2a73',
          color: 'white',
          borderRadius: '12px'
        }}>
          <h3 style={{ marginBottom: '1.5rem' }}>📞 Información de Contacto</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
            <p>📧 <a href="mailto:ventas@resveltex.com" style={{ color: 'white', textDecoration: 'underline' }}>
              ventas@resveltex.com
            </a></p>
            <p>📱 WhatsApp: +57 312 757 6928</p>
            <p>📍 Colombia</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 